export enum TipoItemProduto {
    "borda" = "borda",
    "sabor" = "sabor",
    "item" = "item",
    "massa" = "massa",
    "observacao" = "observacao"
}